import { render, staticRenderFns } from "./SplitPanel.vue?vue&type=template&id=ac6bd8f8&scoped=true"
import script from "./SplitPanel.vue?vue&type=script&lang=js"
export * from "./SplitPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac6bd8f8",
  null
  
)

export default component.exports